exports = module.exports = require("./../../../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label>*{pointer-events:none}", "", {"version":3,"sources":["/./src/components/forms/checkbox.vue"],"names":[],"mappings":"AACA,QAAY,mBAAqB,CAChC","file":"checkbox.vue","sourcesContent":["\nlabel > * { pointer-events: none;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader?sourceMap!./~/.10.0.2@vue-loader/lib/style-rewriter.js?id=data-v-97466cd0!./~/.10.0.2@vue-loader/lib/selector.js?type=styles&index=0!./src/components/forms/checkbox.vue
// module id = 102
// module chunks = 0